import { assert_equal } from '@shared/asserts/utils_asserts';

export enum ENUM__invocation_type {
  /*
   * GRID2D
   */

  GRID2D__VIEW = 'GRID2D__VIEW', //todo: rename value

  /*
   * IMAGE
   */
  IMAGE__MASK_TO_TENSOR_IMAGE_MASK_BOOLEAN = 'IMAGE__MASK_TO_TENSOR_IMAGE_MASK_BOOLEAN',
  IMAGE__MASK_CREATE_GRADIENT = 'IMAGE__MASK_CREATE_GRADIENT',
  IMAGE__VIEWPORT = 'IMAGE__VIEWPORT',
  IMAGE__COLOR_MAP = 'IMAGE__COLOR_MAP',
  IMAGE__PASTE_WITH_MASK = 'IMAGE__PASTE_WITH_MASK',
  IMAGE__TRIM_COLOR = 'IMAGE__TRIM_COLOR',
  IMAGE__SHARP = 'IMAGE__SHARP',
  IMAGE__SCALE = 'IMAGE__SCALE',
  IMAGE__EXTEND = 'IMAGE__EXTEND',

  /*
   * VISION
   */
  VISION_CV2__LINE__CANNY = 'VISION_CV2__LINE__CANNY',
  VISION_CV2__LINE__CANNY_AUTO = 'VISION_CV2__LINE__CANNY_AUTO',
  VISION_CV2__LINE__CANNY_SEMI_AUTO = 'VISION_CV2__LINE__CANNY_SEMI_AUTO',

  VISION_ML__LINE__HED = 'VISION_ML__LINE__HED',
  VISION_ML__SEGMENT_SEGFORMER = 'VISION_ML__SEGMENT_SEGFORMER',
  VISION_ML__DEPTH_ANYTHING = 'VISION_ML__DEPTH_ANYTHING',

  VISION_ML__REMBG = 'VISION_ML__REMBG',

  /*
   *
   */

  TOOL_VIEW__INFO = 'TOOL_VIEW__INFO',
  /*
   * LATENTS
   */
  LATENTS_BLEND = 'LATENTS_BLEND',
  LATENTS__CREATE_NOISE = 'LATENTS__CREATE_NOISE',

  /*
   * SD
   */

  SD__DENOISE_LATENTS_PIPELINE = 'SD__DENOISE_LATENTS_PIPELINE',
  SD__TEXT_ENCODER = 'SD__TEXT_ENCODER',
  SD__TEXT_ENCODER_MASKED = 'SD__TEXT_ENCODER_MASKED',
  SD__LATENTS_TO_IMAGE = 'SD__LATENTS_TO_IMAGE',
  SD__IMAGE_TO_LATENTS = 'SD__IMAGE_TO_LATENTS',
  SD__LORA_SELECT = 'SD__LORA_SELECT',
  SD__CONTROL_NET = 'SD__CONTROL_NET',
  SD__IP_ADAPTER = 'SD__IP_ADAPTER',
  SD__T2I_ADAPTER = 'SD__T2I_ADAPTER',

  /*
   *
   */
  SPANDREL__UPSCALER = 'SPANDREL__UPSCALER',
  SPANDREL__UPSCALER_TO_SIDE = 'SPANDREL__UPSCALER_TO_SIDE',
}

const ENUM = ENUM__invocation_type;

export namespace ENUM__invocation_type_utils {
  export function get_group_grid2d() {
    return [ENUM.GRID2D__VIEW];
  }
  export function get_group_sd() {
    return [
      ENUM.LATENTS__CREATE_NOISE,
      ENUM.SD__DENOISE_LATENTS_PIPELINE,
      ENUM.SD__TEXT_ENCODER,
      ENUM.SD__TEXT_ENCODER_MASKED,
      ENUM.SD__LATENTS_TO_IMAGE,
      ENUM.SD__IMAGE_TO_LATENTS,
      ENUM.SD__LORA_SELECT,
      ENUM.SD__CONTROL_NET,
      ENUM.SD__IP_ADAPTER,
      ENUM.SD__T2I_ADAPTER,
    ];
  }

  export function get_group_vision() {
    return [
      ENUM.VISION_CV2__LINE__CANNY,
      ENUM.VISION_CV2__LINE__CANNY_SEMI_AUTO,
      ENUM.VISION_CV2__LINE__CANNY_AUTO,
      //
      ENUM.VISION_ML__LINE__HED,
      //
      ENUM.VISION_ML__SEGMENT_SEGFORMER,
      //
      ENUM.VISION_ML__DEPTH_ANYTHING,
      //
      ENUM.VISION_ML__REMBG,
    ];
  }

  export function get_group_image() {
    return [
      ENUM.IMAGE__VIEWPORT,
      ENUM.IMAGE__MASK_CREATE_GRADIENT,
      ENUM.IMAGE__MASK_TO_TENSOR_IMAGE_MASK_BOOLEAN,
      ENUM.IMAGE__COLOR_MAP,
      ENUM.IMAGE__PASTE_WITH_MASK,
      ENUM.IMAGE__TRIM_COLOR,
      ENUM.IMAGE__SHARP,
      ENUM.IMAGE__SCALE,
      ENUM.IMAGE__EXTEND,
    ];
  }

  export function get_group_info() {
    return [ENUM.TOOL_VIEW__INFO];
  }
  export function get_group_latents() {
    return [ENUM.LATENTS_BLEND];
  }
  export function get_group_spandrel() {
    return [ENUM.SPANDREL__UPSCALER, ENUM.SPANDREL__UPSCALER_TO_SIDE];
  }
}

let amount =
  ENUM__invocation_type_utils.get_group_grid2d().length +
  ENUM__invocation_type_utils.get_group_sd().length +
  ENUM__invocation_type_utils.get_group_image().length +
  ENUM__invocation_type_utils.get_group_vision().length +
  ENUM__invocation_type_utils.get_group_spandrel().length +
  ENUM__invocation_type_utils.get_group_info().length +
  ENUM__invocation_type_utils.get_group_latents().length;

assert_equal(amount, Object.values(ENUM__invocation_type).length);
